import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'tachyons'
import './engines/index'
import { Dispatch, BaseComponent, Request } from './components/architecture/frontend/index'
import Apollo from './apollo'
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import App from './App';

process.env.NODE_ENV === 'production' && Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_ID,
  integrations: [new Integrations.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

Request(Dispatch, Apollo)

ReactDOM.render(
  <React.StrictMode>
    <BaseComponent Component={App} />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
